import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'providerManagement',
  initialState: {
    userListLoading: false,
    usersList: [],
    userListDetails: {},
    userPaginationData: {},
    userListDetailsLoading: false,
    // store
    storeList: [],
    storeListLoading: false,
    storePaginationData: {},
    storeListDetails: {},
    storeListDetailsLoading: false,
    updateStoreList: false,
    ExcelError: [],
    // company
    companyListLoading: false,
    companyList: '',
    companyPaginationData: {},
    companyListDetails: {},
    companyListDetailsLoading: false,
    updateCompanyList: false,

    // distributor
    distributorListLoading: false,
    distributorPaginationData: {},
    distributorList: [],
    distributorListDetails: {},
    distributorListDetailsLoading: false,
    updateDistributorList: false,

    modalOpen: false,
    ApiError: '' || [],
  },
  reducers: {
    //user
    getUserData: (state, { payload }) => {
      state.userListLoading = true
    },
    getUserDataSuccess: (state, { payload }) => {
      state.userListLoading = false
      state.usersList = payload?.payload?.data

      state.userPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getUserDataFailure: (state, { payload }) => {
      state.userListLoading = false
    },

    getUserDetailsListApiData: (state, { payload }) => {
      state.userListDetailsLoading = true
    },
    getUserDetailsListApiSuccess: (state, { payload }) => {
      state.userListDetailsLoading = false
      state.userListDetails = payload?.payload?.data
    },
    getUserDetailsListApiFailure: (state, { payload }) => {
      state.userListDetailsLoading = false
    },
    // Store List
    storeListApiData: (state, { payload }) => {
      state.storeListLoading = true
    },
    getStoreListApiSuccess: (state, { payload }) => {
      state.storeListLoading = false
      state.storeList = payload?.payload?.data
      state.storePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStoreListApiFailure: (state, { payload }) => {
      state.storeListLoading = false
    },
    getStoreDetailsListApiData: (state, { payload }) => {
      state.storeListDetailsLoading = true
    },
    getStoreDetailsListApiSuccess: (state, { payload }) => {
      state.storeListDetailsLoading = false
      state.storeListDetails = payload?.payload?.data
    },
    getStoreDetailsListApiFailure: (state, { payload }) => {
      state.storeListDetailsLoading = false
    },
    // add store By Admin
    addStoreByAdminApiData: (state, { payload }) => {
      state.updateStoreList = false
    },
    addStoreByAdminApiSuccess: (state, { payload }) => {
      state.updateStoreList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addStoreByAdminApiFailure: (state, { payload }) => {
      state.updateStoreList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // update Store
    updateStoreByAdminApiData: (state, { payload }) => {
      state.updateStoreList = false
      state.storeList = state.storeList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreByAdminApiSuccess: (state, { payload }) => {
      state.updateStoreList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreByAdminApiFailure: (state, { payload }) => {
      state.updateStoreList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Delete Store Data
    deleteStoreApiData: (state, { payload }) => {
      let updatedStoreList = state.storeList?.filter((item) => item.id !== payload?.id)
      state.storeList = updatedStoreList
      state.updateStoreList = false
    },
    deleteStoreApiSuccess: (state, { payload }) => {
      state.updateStoreList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreApiFailure: (state, { payload }) => {
      state.updateStoreList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Status Active
    activateStoreApiData: (state, { payload }) => {
      state.updateStoreList = false
      state.storeListLoading = true
    },
    activateStoreApiSuccess: (state, { payload }) => {
      state.updateStoreList = true
      state.storeListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activateStoreApiFailure: (state, { payload }) => {
      state.updateStoreList = false
      state.storeListLoading = false
    },
    // Status DeActive
    deActiveStoreApiData: (state, { payload }) => {
      state.updateStoreList = false
      state.storeListLoading = true
    },
    deActiveStoreApiSuccess: (state, { payload }) => {
      state.updateStoreList = true
      state.storeListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deActiveStoreApiFailure: (state, { payload }) => {
      state.updateStoreList = false
      state.storeListLoading = false
    },

    resetProviderManagementError: (state, { payload }) => {
      state.modalOpen = false
      state.ApiError = ''
      state.ExcelError = []
    },

    // Add Pharmacy By Excel through Admin
    addBulkStoreByExcelApiData: (state, { payload }) => {
      state.bulkStoreExcelLoading = true
      state.modalOpen = false
    },
    addBulkStoreByExcelApiSuccess: (state, { payload }) => {
      state.bulkStoreExcelLoading = false
      state.modalOpen = true
      state.ExcelError = payload?.payload?.errors || []
    },
    addBulkStoreByExcelApiFailure: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // company
    companyListApiData: (state, { payload }) => {
      state.companyListLoading = true
    },
    companyListApiSuccess: (state, { payload }) => {
      state.companyListLoading = false
      state.companyList = payload?.payload?.data
      state.companyPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    companyListApiFailure: (state, { payload }) => {
      state.companyListLoading = false
    },

    // Company Details
    companyDetailsListApiData: (state, { payload }) => {
      state.companyListDetailsLoading = true
    },
    companyDetailsListApiSuccess: (state, { payload }) => {
      state.companyListDetailsLoading = false
      state.companyListDetails = payload?.payload?.data
    },
    companyDetailsListApiFailure: (state, { payload }) => {
      state.companyListDetailsLoading = false
    },

    // Add Company
    addCompanyByAdminApiData: (state, { payload }) => {
      state.updateCompanyList = false
    },
    addCompanyByAdminApiSuccess: (state, { payload }) => {
      state.updateCompanyList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addCompanyByAdminApiFailure: (state, { payload }) => {
      state.updateCompanyList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Company
    updateCompanyByAdminApiData: (state, { payload }) => {
      state.updateCompanyList = false
      state.companyList = state.companyList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateCompanyByAdminApiSuccess: (state, { payload }) => {
      state.updateCompanyList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateCompanyByAdminApiFailure: (state, { payload }) => {
      state.updateCompanyList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Delete Company
    deleteCompanyApiData: (state, { payload }) => {
      let updatedCompanyList = state.companyList?.filter((item) => item.id !== payload?.id)
      state.companyList = updatedCompanyList
      state.updateCompanyList = false
    },
    deleteCompanyApiSuccess: (state, { payload }) => {
      state.updateCompanyList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteCompanyApiFailure: (state, { payload }) => {
      state.updateCompanyList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Active Company
    activateCompanyApiData: (state, { payload }) => {
      state.updateCompanyList = false
      state.companyListLoading = true
    },
    activateCompanyApiSuccess: (state, { payload }) => {
      state.updateCompanyList = true
      state.companyListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activateCompanyApiFailure: (state, { payload }) => {
      state.updateCompanyList = false
      state.companyListLoading = false
    },

    // DeActive Company
    deActiveCompanyApiData: (state, { payload }) => {
      state.updateCompanyList = false
      state.companyListLoading = true
    },
    deActivateCompanyApiSuccess: (state, { payload }) => {
      state.updateCompanyList = true
      state.companyListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deActivateCompanyApiFailure: (state, { payload }) => {
      state.updateCompanyList = false
      state.companyListLoading = false
    },

    // distributor
    distributorListApiData: (state, { payload }) => {
      state.distributorListLoading = true
    },
    distributorListApiSuccess: (state, { payload }) => {
      state.distributorListLoading = false
      state.distributorList = payload?.payload?.data
      state.distributorPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    distributorListApiFailure: (state, { payload }) => {
      state.distributorListLoading = false
    },

    // distributor Details
    distributorDetailsListApiData: (state, { payload }) => {
      state.distributorListDetailsLoading = true
    },
    distributorDetailsListApiSuccess: (state, { payload }) => {
      state.distributorListDetailsLoading = false
      state.distributorListDetails = payload?.payload?.data
    },
    distributorDetailsListApiFailure: (state, { payload }) => {
      state.distributorListDetailsLoading = false
    },

    // distributor Company
    addDistributorByAdminApiData: (state, { payload }) => {
      state.updateDistributorList = false
    },
    addDistributorByAdminApiSuccess: (state, { payload }) => {
      state.updateDistributorList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addDistributorByAdminApiFailure: (state, { payload }) => {
      state.updateDistributorList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // distributor Company
    updateDistributorByAdminApiData: (state, { payload }) => {
      state.updateDistributorList = false
      state.distributorList = state.distributorList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateDistributorByAdminApiSuccess: (state, { payload }) => {
      state.updateDistributorList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateDistributorByAdminApiFailure: (state, { payload }) => {
      state.updateDistributorList = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Delete distributor
    deleteDistributorApiData: (state, { payload }) => {
      let updatedDistributorList = state.distributorList?.filter((item) => item.id !== payload?.id)
      state.distributorList = updatedDistributorList
      state.updateDistributorList = false
    },
    deleteDistributorApiSuccess: (state, { payload }) => {
      state.updateDistributorList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteDistributorApiFailure: (state, { payload }) => {
      state.updateDistributorList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Active distributor
    activateDistributorApiData: (state, { payload }) => {
      state.updateDistributorList = false
      state.distributorListLoading = true
    },
    activateDistributorApiSuccess: (state, { payload }) => {
      state.updateDistributorList = true
      state.distributorListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activateDistributorApiFailure: (state, { payload }) => {
      state.updateDistributorList = false
      state.distributorListLoading = false
    },

    // DeActive distributor
    deActiveDistributorApiData: (state, { payload }) => {
      state.updateDistributorList = false
      state.distributorListLoading = true
    },
    deActivateDistributorApiSuccess: (state, { payload }) => {
      state.updateDistributorList = true
      state.distributorListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deActivateDistributorApiFailure: (state, { payload }) => {
      state.updateDistributorList = false
      state.distributorListLoading = false
    },
  },
})

export const {
  getUserData,
  getUserDataSuccess,
  getUserDataFailure,

  getUserDetailsListApiData,
  getUserDetailsListApiSuccess,
  getUserDetailsListApiFailure,
  // Store List
  storeListApiData,
  getStoreListApiSuccess,
  getStoreListApiFailure,

  // store Details
  getStoreDetailsListApiData,
  getStoreDetailsListApiSuccess,
  getStoreDetailsListApiFailure,

  // add store By Admin
  addStoreByAdminApiData,
  addStoreByAdminApiSuccess,
  addStoreByAdminApiFailure,

  // update Store
  updateStoreByAdminApiData,
  updateStoreByAdminApiSuccess,
  updateStoreByAdminApiFailure,

  // Add Bulk Store
  addBulkStoreByExcelApiData,
  addBulkStoreByExcelApiSuccess,
  addBulkStoreByExcelApiFailure,

  // company
  companyListApiData,
  companyListApiSuccess,
  companyListApiFailure,

  // Company Details
  companyDetailsListApiData,
  companyDetailsListApiSuccess,
  companyDetailsListApiFailure,

  // Add Company
  addCompanyByAdminApiData,
  addCompanyByAdminApiSuccess,
  addCompanyByAdminApiFailure,

  // Update Company
  updateCompanyByAdminApiData,
  updateCompanyByAdminApiSuccess,
  updateCompanyByAdminApiFailure,
  // Delete
  deleteCompanyApiData,
  deleteCompanyApiSuccess,
  deleteCompanyApiFailure,

  // Active Company
  activateCompanyApiData,
  activateCompanyApiSuccess,
  activateCompanyApiFailure,

  // DeActive Company
  deActiveCompanyApiData,
  deActivateCompanyApiSuccess,
  deActivateCompanyApiFailure,

  // distributor
  distributorListApiData,
  distributorListApiSuccess,
  distributorListApiFailure,

  // distributor Details
  distributorDetailsListApiData,
  distributorDetailsListApiSuccess,
  distributorDetailsListApiFailure,

  // distributor Company
  addDistributorByAdminApiData,
  addDistributorByAdminApiSuccess,
  addDistributorByAdminApiFailure,

  // distributor Company
  updateDistributorByAdminApiData,
  updateDistributorByAdminApiSuccess,
  updateDistributorByAdminApiFailure,
  // Delete distributor
  deleteDistributorApiData,
  deleteDistributorApiSuccess,
  deleteDistributorApiFailure,

  // Active distributor
  activateDistributorApiData,
  activateDistributorApiSuccess,
  activateDistributorApiFailure,

  // DeActive distributor
  deActiveDistributorApiData,
  deActivateDistributorApiSuccess,
  deActivateDistributorApiFailure,

  // Delete Store Data
  deleteStoreApiData,
  deleteStoreApiSuccess,
  deleteStoreApiFailure,

  // Status Active
  activateStoreApiData,
  activateStoreApiSuccess,
  activateStoreApiFailure,
  // Status DeActive
  deActiveStoreApiData,
  deActiveStoreApiSuccess,
  deActiveStoreApiFailure,

  resetProviderManagementError,
} = slice.actions

export default slice.reducer
